import { render, staticRenderFns } from "./NewMessagesPopUp.vue?vue&type=template&id=3dacd786&"
import script from "./NewMessagesPopUp.vue?vue&type=script&lang=js&"
export * from "./NewMessagesPopUp.vue?vue&type=script&lang=js&"
import style0 from "./NewMessagesPopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports